import { userHasAccess } from "../access-control/permissions";
import usePermissions from "../access-control/queries/usePermissions";
import { RBACAccessLevel, RBACDomain } from "../access-control/types";
import useUsers from "./useUsers";

/**
 * Boolean or null if loading
 * */
export type AccessResult = null | boolean;

/*
 * Returns boolean or null if permissions are still loading
 **/
export function useUserHasAccess(
  domain: RBACDomain,
  accessLevel: RBACAccessLevel,
): AccessResult {
  const usersState = useUsers();
  const { data: rolePermissions, isLoading: permsLoading } = usePermissions();

  if (permsLoading || usersState.loading) {
    return null;
  }

  return userHasAccess(
    usersState.currentUser,
    rolePermissions,
    domain,
    accessLevel,
  );
}
